export const CONTEST_ID = 1;

export const COUNT_LINES = ["1st", "2nd", "3rd", "4th"] as const;
